import React, { useState } from "react";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import LoginWithMpin from "./LoginWithMpin";
import LoginMpinPassWord from "./LoginMpinPassWord";
import ForgotPassOtp from "./ForgotPassOtp";
import HomePage from "../../HomePage/HomePage";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../axios";
import { useDispatch } from "react-redux";
import { loginFailure, loginStart, loginSuccess } from "../../redux/userReducer";

export default function LoginWithPassWord({ studentDetails, setLogin }) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [isInProgress, setIsInProgress] = useState(false);
  const [LoginWithPassWord, setLoginWithPassWord] = useState({
    loginInstedMpin: false,
    backArrow: false,
    forgotPass: false,
    loginSucess: false,
  });
  const schoolCode = localStorage.getItem("schoolCode");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlepasswordChange = (event) => {
    const { value } = event.target;
    setPassword(value);
  };
  const toggleshowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async () => {
    setIsInProgress(true);
    dispatch(loginStart());

    try {
      let res = await axios.post(`/studentAuth/loginWithPassword`, {
        unique_id: studentDetails?.addmissionNumber,
        password: password,
        school_code: schoolCode,

      });
      res && dispatch(loginSuccess(res.data.data));
      if (res) {
        localStorage.setItem(
          "School_id",
          JSON.stringify(res?.data?.data?.addmission_no)
        );
        localStorage.setItem(
          "AuthToken",
          JSON.stringify(res.data?.data?.accessToken)
        );
      }
      // window.location.replace("/HomePage");
      navigate("/loginSuccessful");
    } catch (error) {
      dispatch(loginFailure());
      setErrorMessage(error.response.data.message);
      setIsInProgress(false);
      console.log(error);
    }
  };

  // const handleSendOtp = async () => {
  //   try {
  //     let res = await axios.post(`/studentAuth/generateEmailOtp`, {
  //       email_id: studentDetails?.email,
  //     });
  //     res &&
  // setLoginWithPassWord({
  //   ...LoginWithPassWord,
  //   forgotPass: true,
  // });
  //   } catch (error) {
  //     setErrorMessage("Something went wrong!!!");
  //     console.log(error);
  //   }
  // };

  return (
    <div>
      {!LoginWithPassWord.loginInstedMpin &&
        !LoginWithPassWord.backArrow &&
        !LoginWithPassWord.forgotPass &&
        !LoginWithPassWord.loginSucess && (
          <div className="ContainerRegister h-100">
            <div className="row">
              <div className="col-md-3 p-0 bannerContainer">
                <img
                  className="bannerImg"
                  alt="icon"
                  src="/LoginRegister/BannerImg.png"
                ></img>
              </div>
              <div className="col-md-9 RegisterDetailContainer">
                <>
                  <div
                    className="backLoginIcon"
                    onClick={(e) =>
                      setLogin((prev) => ({
                        ...prev,
                        mpinLogin: false,
                        passwordLogin: false,
                      }))
                    }
                  >
                    <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
                  </div>

                  <form>
                    <div className="InsideDetailCpntainer">
                      <div className="d-flex justify-content-center">
                        <img
                          className="registrationIcon"
                          src="/StudentImg/BreathSchoolLogo.svg"
                          alt="icon"
                        />
                      </div>
                      <div className="d-flex justify-content-center headerRegistration mt-3">
                        {/* Welcome {studentDetails?.name} */}
                        Welcome back!
                      </div>
                      <div className="UnlockFaceIdText d-flex justify-content-center mt-2 ">
                        Login with Password
                      </div>

                      <div className="d-flex justify-content-between p-3 align-items-center registrationMPinInput  mt-4">
                        <input
                          type="text"
                          className="otpInput"
                          readOnly="true"
                          value={studentDetails?.addmissionNumber}
                        />
                      </div>

                      <div
                        style={{ borderColor: errorMessage && "#D40D12" }}
                        className="d-flex justify-content-between p-3 align-items-center registrationMPinInput  mt-4"
                      >
                        <input
                          style={{ borderColor: errorMessage && "red" }}
                          type={showPassword ? "text" : "password"}
                          id="password"
                          className="otpInput"
                          name="password"
                          placeholder="Enter Password"
                          value={password}
                          onChange={handlepasswordChange}
                          required
                          autocomplete="off"
                          minLength={8}
                          maxLength={64}
                        />

                        {errorMessage ? (
                          <span
                            style={{ color: "#D40D12" }}
                            className="align-self-center w-50"
                          >
                            Password error!
                          </span>
                        ) : (
                          <span onClick={toggleshowPassword}>
                            {showPassword ? <FiEye /> : <FiEyeOff />}
                          </span>
                        )}
                      </div>
                      <div className="d-flex flex-column justify-content-center mt-4">
                        <button
                          type="submit"
                          disabled={password === "" || isInProgress}
                          className="RegisterBtn"
                          onClick={handleLogin}
                        >
                          Login
                        </button>
                      </div>
                      <div
                        className="skipfacetext d-flex justify-content-center mt-3"
                        onClick={() =>
                          setLoginWithPassWord({
                            ...LoginWithPassWord,
                            forgotPass: true,
                          })
                        }
                      >
                        Forgot Password?
                      </div>
                      <div className=" d-flex justify-content-center mt-4 ">
                        <div
                          className="loginpasswordInstead mt-5"
                          onClick={(e) => {
                            setLoginWithPassWord({
                              ...LoginWithPassWord,
                              loginInstedMpin: true,
                            });
                          }}
                        >
                          Login with PIN instead{" "}
                        </div>
                      </div>
                    </div>
                  </form>
                </>
              </div>
            </div>
          </div>
        )}
      {LoginWithPassWord.loginInstedMpin && (
        <LoginWithMpin studentDetails={studentDetails} />
      )}
      {LoginWithPassWord.backArrow && (
        <LoginMpinPassWord studentDetails={studentDetails} />
      )}
      {LoginWithPassWord.forgotPass && (
        <ForgotPassOtp studentDetails={studentDetails} />
      )}
      {/* {LoginWithPassWord.loginSucess && <HomePage />} */}
    </div>
  );
}
